import { mapKeys, snakeCase } from "lodash";
import type { SnakeCase } from "type-fest";

export const keysToSnakeCase = <Obj extends Record<string, unknown>>(obj?: Obj) =>
  mapKeys<Record<string, unknown>>(obj ?? {}, (_, key) => snakeCase(key)) as {
    [Key in keyof Obj & string as SnakeCase<Key>]: Obj[Key];
  };
